import React, {useEffect, useState} from 'react';
import Ratio from 'react-ratio';

import Skeleton from 'coreComponents/Skeleton';

import {IImageProps} from './IImage';

const Image = ({src, alt, title, className, onImageLoaded, onClick, ratio, showSkeleton = true, ref}: IImageProps) => {
	const [imageLoaded, setImageLoaded] = useState(false);

	const handleOnLoad = () => {
		setImageLoaded(true);
	};

	useEffect(() => {
		onImageLoaded && onImageLoaded();
	}, [imageLoaded]);

	const renderImage = () => {
		return (
			<>
				{!imageLoaded && showSkeleton ? <Skeleton /> : null}
				<img
					ref={ref}
					className={className}
					onLoad={handleOnLoad}
					onClick={onClick}
					src={src}
					alt={alt}
					title={title}
				/>
			</>
		);
	};

	if (ratio) {
		return <Ratio ratio={ratio}>{renderImage()}</Ratio>;
	}

	return renderImage();
};

export default Image;
